var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showPrice)?_c('div',{staticClass:"offer-original-price",style:(_vm.customStyle)},[_vm._v(" "+_vm._s(_vm.formattedPrice)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }